"use strict";
var ApiCoverageGroups = (function () {
    function ApiCoverageGroups() {
        this.included = [];
        /**
         * These coverages come from the 'included' coverages; they have a type of 'Extra'
         */
        this.bonus = [];
        this.optional = [];
    }
    return ApiCoverageGroups;
}());
exports.ApiCoverageGroups = ApiCoverageGroups;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-coverage-groups.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-coverage-groups.model.js